import {gql} from "@apollo/client";

export const GET_OPEN_WITHDRAWALS = gql`
          query GetOpenWithdrawals {
                 openWithdrawals {
                    id
                      timeStamp
                      lastStatusUpdate
                      product {
                        id
                        name
                      }
                      iban
                      amount
                      status
                      type
                 }
          }`;
